import Cookies from 'js-cookie'

const TokenKey = 'speech_mobile_token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token, opt = { expires: 1 }) {
  return Cookies.set(TokenKey, token, opt)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}
